import { Injectable } from '@angular/core';
import { filter } from 'rxjs/internal/operators/filter';
import { fromEvent, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfiguratorBridgeService {

   private _result$ = new Subject<Record<string, string>>();
  result$ = this._result$.asObservable();

  constructor() {
    fromEvent<MessageEvent>(window, 'message').pipe(
      filter(e => e.origin === window.location.origin),
      filter(e => e.data?.type === 'IFRAME_STEP_COMPLETE')
    ).subscribe(e => this._result$.next(e.data.payload));
  }
}
